import React, { useEffect, useState } from 'react';
import CargomaticModal from 'components/v2/modal';
import CargomaticInput from 'components/v2/input';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { getShipments, generateAndSendBulkRateConfirmation, } from '../../../utils/ShipmentWebAPIUtils';
function BulkGenerateRateConfirmation({ showModal, selectedShipments, onHide, t, }) {
    const [shipments, setShipments] = useState([]);
    const [emailAddresses, setEmailAddresses] = useState({});
    async function fetchShipments() {
        var _a;
        const result = await getShipments({ _id: selectedShipments });
        setShipments((_a = result === null || result === void 0 ? void 0 : result.entity) === null || _a === void 0 ? void 0 : _a.items);
    }
    useEffect(() => {
        fetchShipments();
    }, [selectedShipments]);
    function generatePayload() {
        return Object.keys(emailAddresses).map((jobId) => {
            return {
                jobId,
                addresses: emailAddresses[jobId].split(','),
            };
        });
    }
    function handleSave() {
        generateAndSendBulkRateConfirmation(generatePayload());
        handleClose();
    }
    function handleApplyBelow(currentIndex) {
        const currentShipment = shipments[currentIndex];
        const currentValue = emailAddresses[currentShipment._id];
        const updates = Array(shipments.length - currentIndex)
            .fill()
            .reduce((currentData, _currentValue, index) => {
            const shipment = shipments[currentIndex + index];
            currentData[shipment._id] = currentValue;
            return currentData;
        }, {});
        setEmailAddresses((prevState) => {
            return Object.assign(Object.assign({}, prevState), updates);
        });
    }
    function handleRemoveShipment(shipmentId) {
        setShipments((currentState) => {
            return currentState.filter((shipment) => shipment._id !== shipmentId);
        });
    }
    function handleClose() {
        onHide();
    }
    function getFooter() {
        return (React.createElement("div", { className: "flex justify-end button-group" },
            React.createElement("button", { className: "block button secondary-action", onClick: handleClose }, titleize(t('CLOSE'))),
            React.createElement("button", { className: "button button-green flex items-center", disabled: false, onClick: handleSave },
                React.createElement("span", null, t('SEND_ALL')))));
    }
    function getBody() {
        const rows = shipments.map((shipment, index) => {
            return (React.createElement("tr", null,
                React.createElement("td", null, shipment.shipment_id),
                React.createElement("td", null,
                    React.createElement(CargomaticInput, { type: "text", name: t('EMAIL'), placeholder: t('EMAIL_ADDRESS'), className: "mb-4", value: emailAddresses[shipment._id], onChange: (value) => {
                            setEmailAddresses((currentEmails) => {
                                return Object.assign(Object.assign({}, currentEmails), { [shipment._id]: value });
                            });
                        } })),
                React.createElement("td", null,
                    React.createElement("button", { className: "button button-hollow-green ml-8", type: "button", onClick: () => handleApplyBelow(index) }, titleize(t('APPLY')))),
                React.createElement("td", null,
                    React.createElement("button", { className: "button text-grey-dark hover:text-grey-darker", onClick: () => handleRemoveShipment(shipment._id) },
                        React.createElement("i", { className: "fa fa-remove" })))));
        });
        return (React.createElement("div", { className: "p-4 bg-gray-100 overflow-y-auto", style: { maxHeight: '80vh' } },
            React.createElement("table", { className: "min-w-full" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("td", { className: "text-sm uppercase text-gray-500" }, titleize(t('SHIPMENT', { count: 1 }))),
                        React.createElement("td", { className: "text-sm uppercase text-gray-500" }, titleize(t('EMAIL'))),
                        React.createElement("td", null,
                            React.createElement("span", { className: "ml-8 uppercase text-sm text-gray-500" }, titleize(t('APPLY_BELOW')))),
                        React.createElement("td", { className: "text-sm uppercase text-gray-500" }, titleize(t('REMOVE'))))),
                React.createElement("tbody", null, rows))));
    }
    return (React.createElement(CargomaticModal, { dialogClassName: "modal-override-medium", title: t('SEND_RATE_CONFIRMATION'), style: { top: '20%' }, show: showModal, onHide: handleClose, body: getBody(), footer: getFooter() }));
}
export default withTranslation()(BulkGenerateRateConfirmation);
